<template>
	<div class="solution-con">
		<mobile-header :active-route="activeRoute" @active-up="beforeRoute"></mobile-header>
		<mobile-main
		ref="activeMain"
		:active-route="activeRoute"
		:mainConStyle="mainConStyle"
		:bannerImage="bannerImage"></mobile-main>
		<mobile-footer :linkVisible="linkVisible" :applyFooterStyle="applyFooterStyle"></mobile-footer>
	</div>
</template>
<script>
    import bannerImageSolution from '@/assets/mobile/resource/images/solution/banner_solutions_key.png';
    import bannerImageProfessional from '@/assets/mobile/resource/images/solution/banner_solutions_professional.png';
    import bannerImageIc from '@/assets/mobile/resource/images/solution/banner_solutions_ic.png';
    import bannerImageAccess from '@/assets/mobile/resource/images/solution/banner_solutions_access.png';
    import bannerImageHpc from '@/assets/mobile/resource/images/solution/banner_solutions_hpc.png';
    import bannerImageCustomization from '@/assets/mobile/resource/images/solution/banner_solutions_customization.png';
    import bannerImagePrecision from '@/assets/mobile/resource/images/solution/banner_solutions_precision.png';
    import bannerImageOptics from '@/assets/mobile/resource/images/solution/banner_solutions_optics.png';
    import bannerImageIme from '@/assets/mobile/resource/images/solution/banner_solutions_ime.png';
    import bannerImageSystem from '@/assets/mobile/resource/images/solution/banner_solutions_system.png';
    import bannerImageIntelligent from '@/assets/mobile/resource/images/solution/banner_solutions_intelligent.png';
    import bannerImageWeb from '@/assets/mobile/resource/images/solution/banner_solutions_web.png';
    export default{
        components: {
            MobileHeader: () => import('@/components/mobile/zh-cn/header'),
            MobileFooter: () => import('@/components/mobile/zh-cn/footer'),
            MobileMain: () => import('@/components/mobile/zh-cn/main'),
        },
        data(){
            return {
                linkVisible: false,
                mainConStyle: {},
                applyFooterStyle: {
                    minHeight: '9.5rem',
                    background: '#363940'
                },
                bannerImage: '',
                activeRoute: {},
            };
        },
        methods: {
            beforeRoute(currentActiveRoute){
                const _this = this;
                var activeRoute = [];
                const activeRouteParams = _this.$route.params;
                if ($.type(currentActiveRoute) === 'undefined') {
                    if ($.isEmptyObject(activeRouteParams) === false) {
                        activeRoute = activeRouteParams;
                    } else {
                        activeRoute = {
                            activeLevel1: 2,
                            activeLevel2: 1
                        };
                    }
                } else {
                    activeRoute = currentActiveRoute;
                }

                _this.activeRoute = activeRoute;
                _this.updateBannerAndMainHeight(activeRoute);
            },
            // 更新Banner 和 页面高度
            updateBannerAndMainHeight(activeRoute){
                const _this = this;
				/*console.log("#3[solution][activeRoute]", activeRoute)*/
                var activeRouteBak = activeRoute;
                if ($.isEmptyObject(activeRoute) === false) {
                    switch (activeRoute.activeLevel2) {
                        case 1:
                            _this.bannerImage = bannerImageSolution;
                            break;
                        case 2:
                            _this.bannerImage = bannerImageProfessional;
                            break;
                        case 3:
                            _this.bannerImage = bannerImageIc;
                            break;
                        case 4:
                            _this.bannerImage = bannerImageAccess;
                            break;
                        case 5:
                            _this.bannerImage = bannerImageHpc;
                            break;
                        case 6:
                            _this.bannerImage = bannerImageCustomization;
                            break;
                        case 7:
                            _this.bannerImage = bannerImagePrecision;
                            break;
                        case 8:
                            _this.bannerImage = bannerImageOptics;
                            break;
                        case 9:
                            _this.bannerImage = bannerImageIme;
                            break;
                        case 10:
                            _this.bannerImage = bannerImageSystem;
                            break;
                        case 11:
                            _this.bannerImage = bannerImageIntelligent;
                            break;
                        case 12:
                            _this.bannerImage = bannerImageWeb;
                            break;
                        default:
                            _this.bannerImage = bannerImageSolution;
                            break;
                    }
                    if (activeRouteBak.hasOwnProperty('activeLevel3') === false) {
                        activeRouteBak['activeLevel3'] = 0;
                    }
                    var activeRouteBakToString = [activeRouteBak.activeLevel2, activeRouteBak.activeLevel3];
                    switch (activeRouteBakToString.join(',')) {
                        case '1,0':
                            _this.mainConStyle = {'min-height': '102.375rem'};
                            break;
                        case '2,0':
                            _this.mainConStyle = {'min-height': '102.5rem'};
                            break;
                        case '3,0':
                            _this.mainConStyle = {'min-height': '85.5rem'};
                            break;
                        case '4,0':
                            _this.mainConStyle = {'min-height': '167.5rem'};
                            break;
                        case '5,0':
                            _this.mainConStyle = {'min-height': '216.8125rem'};
                            break;
                        case '6,0':
                            _this.mainConStyle = {'min-height': '167.375rem'};
                            break;
                        case '7,1':
                            _this.mainConStyle = {'min-height': '116rem'};
                            break;
                        case '7,2':
                            _this.mainConStyle = {'min-height': '124.25rem'};
                            break;
                        case '7,3':
                            _this.mainConStyle = {'min-height': '116rem'};
                            break;
                        case '7,4':
                            _this.mainConStyle = {'min-height': '103rem'};
                            break;
                        case '7,5':
                            _this.mainConStyle = {'min-height': '134.8125rem'};
                            break;
                        case '7,6':
                            _this.mainConStyle = {'min-height': '219.5rem'};
                            break;
                        case '8,1':
                            _this.mainConStyle = {'min-height': '115.875rem'};
                            break;
                        case '8,2':
                            _this.mainConStyle = {'min-height': '90rem'};
                            break;
                        case '8,3':
                            _this.mainConStyle = {'min-height': '103.688rem'};
                            break;
                        case '8,4':
                            _this.mainConStyle = {'min-height': '94.125rem'};
                            break;
                        case '8,5':
                            _this.mainConStyle = {'min-height': '94.813rem'};
                            break;
                        case '8,6':
                            _this.mainConStyle = {'min-height': '86rem'};
                            break;
                        case '8,7':
                            _this.mainConStyle = {'min-height': '93.375rem'};
                            break;
                        case '9,1':
                            _this.mainConStyle = {'min-height': '99.375rem'};
                            break;
                        case '9,2':
                            _this.mainConStyle = {'min-height': '98.875rem'};
                            break;
                        case '9,3':
                            _this.mainConStyle = {'min-height': '116.25rem'};
                            break;
                        case '9,4':
                            _this.mainConStyle = {'min-height': '142.625rem'};
                            break;
                        case '10,0':
                            _this.mainConStyle = {'min-height': '90.875rem'};
                            break;
                        case '11,1':
                            _this.mainConStyle = {'min-height': '122.875rem'};
                            break;
                        case '11,2':
                            _this.mainConStyle = {'min-height': '206.75rem'};
                            break;
                        case '11,3':
                            _this.mainConStyle = {'min-height': '90.875rem'};
                            break;
                        case '12,0':
                            _this.mainConStyle = {'min-height': '157.375rem'};
                            break;
                    }
                }

                console.log("#1[solution][updateBannerAndMainHeight,activeRouteBakToString]", activeRoute, activeRouteBakToString.join(','))
            }
        },
        watch: {
            $route: {
                handler: 'beforeRoute',
                deep: true
            }
        },
        created(){
            const _this = this;
            _this.beforeRoute();
        },
        mounted(){
            const _this = this;
            _this.$nextTick(() => {
                document.body.style.overflow = 'auto';
            });
        }
    }
</script>

<style scoped="">


</style>


// WEBPACK FOOTER //
// src/components/mobile/zh-cn/solution.vue